import { doc, onSnapshot, setDoc, Timestamp } from "firebase/firestore";
import { db } from "./firebase";

const DEFAULT_PREMIUMS = { gold: 0, silver: 0, platinum: 0 };
export const metalPremiumsRef = doc(db, "systemConfig", "metalPremiums");

export async function saveMetalPremiums(premiums) {
  await setDoc(metalPremiumsRef, { premiums, updatedAt: Timestamp.now() }, { merge: true });
}

export function subscribeMetalPremiums(onChange, onError) {
  return onSnapshot(metalPremiumsRef, (snap) => {
    onChange(snap.exists() ? snap.data().premiums : DEFAULT_PREMIUMS);
  }, onError);
}
